import React from 'react';

export const Button = ({
  title,
  className = '',
  href = null,
  children,
  flat = false,
  outlineDark = false,
  outline = false,
  disabled = false,
  ...rest
}) => {
  const buttonClass = `app-button ${flat ? 'flat' : ''} ${outline ? 'outline' : ''} ${outlineDark ? 'outline-dark' : ''} ${className}`;

  if (href) {
    return (
      <a
        className={buttonClass}
        href={href}
        {...rest}>
        {title ?? children}
      </a>
    );
  }

  return (
    <button
      className={buttonClass}
      {...rest}>
      {title ?? children}
    </button>
  );
};
